import React from 'react';

const LinkExpire = (props: object) => {
  return (
    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clip-path="url(#clip0_11109_9087)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M42.7633 46.701H6.56135C2.93989 46.701 -0.00585938 43.7546 -0.00585938 40.1338V14.4422C-0.00585938 10.8208 2.9406 7.875 6.56135 7.875H42.7629C46.3837 7.875 49.3302 10.8208 49.3302 14.4422V40.1338C49.3302 43.7546 46.3837 46.701 42.7629 46.701H42.7633Z"
          fill="#FBE201"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.13153 45.7311C2.71668 45.4755 2.33172 45.1753 1.98438 44.8371L15.7811 22.7705C16.2758 22.0726 17.5358 22.8088 16.9199 23.6778L3.13153 45.7311ZM48.0094 44.0795C47.7098 44.4764 47.3663 44.8385 46.9863 45.1584L32.4038 23.6793C31.7959 22.8524 33.0138 22.0526 33.5432 22.7722L48.009 44.0795H48.0094Z"
          fill="#FBB701"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.735352 11.4149C1.83188 9.31325 4.03197 7.875 6.56147 7.875H42.7631C45.2701 7.875 47.4529 9.28723 48.5593 11.3579L31.8495 25.0693C27.9622 28.2337 21.5244 28.3571 17.6255 25.192L0.735352 11.4149Z"
          fill="#FBB701"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M48.6156 52.1272C42.3352 52.1272 37.2256 47.0173 37.2256 40.7373C37.2256 34.4573 42.3349 29.3477 48.6156 29.3477C54.8962 29.3477 60.0055 34.4569 60.0055 40.7373C60.0055 47.0173 54.8959 52.1272 48.6156 52.1272Z"
          fill="#D11105"
        />
        <path
          d="M45.3335 36.2119L49.0001 39.8781L52.6667 36.223C52.8127 36.0745 53.0141 35.9939 53.2222 36.0008C53.6401 36.0278 53.973 36.3607 54 36.7785C54.002 36.9792 53.9216 37.1719 53.7777 37.3118L50.1001 41.0002L53.7777 44.6886C53.9216 44.8285 54.002 45.0213 54 45.2219C53.973 45.6397 53.6401 45.9726 53.2222 45.9996C53.0141 46.0065 52.8127 45.9259 52.6667 45.7774L49.0001 42.1223L45.3446 45.7774C45.1986 45.9259 44.9972 46.0065 44.7891 45.9996C44.363 45.9774 44.0225 45.6369 44.0002 45.2108C43.9982 45.0102 44.0786 44.8174 44.2224 44.6775L47.9001 41.0002L44.2113 37.3118C44.0715 37.17 43.9952 36.9776 44.0002 36.7785C44.0272 36.3607 44.3601 36.0278 44.778 36.0008C44.9844 35.9911 45.1856 36.0675 45.3335 36.2119Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_11109_9087">
          <rect width="60" height="60" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default LinkExpire;
